import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumsHeader from "../../common/BreadCrums";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// Unused imports removed
import Pagination from "../../common/TablePagination";
import CreateNewButton from "../../common/CreateNewButton";
import {
  deleteFranchise,
  getFranchises,
  getLocationById,
} from "../../../services/franchiseService";
import CancelPopup from "../../common/CancelPopup";
import deleteImg from "../../../Assets/Images/deleteImg.svg";
import Loader from "../../common/Loader";
import TradingHoursPopup from "../../Admin/FundraiserList/TradingHoursPopup";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
import SearchBar from "../../common/SearchBar";
import { Dropdown } from "antd";
import FilterPanel from "../../common/FilterPanel";
// Unused import removed
import DetailsModal from "../../common/DetailsModal";
import PopupContent from "./PopupContent";

const FranchiseListTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.franchiseReducer?.loading);
  const selectedMerchant = useSelector(
    (state) => state?.merchantReducer.selectedMerchent
  );
  const [isTradeOpen, setIsTradeOpen] = useState();
  const [tradeHours] = useState();
  const [statusToggled] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [storeDetails, setStoreDetails] = useState(null);

  const items = [
    {
      title: "Other Stores",
    },
    {
      title: "Stores List",
    },
  ];

  const columns = [
    {
      name: "No.",
    },
    {
      name: "Merchant Name",
    },
    {
      name: "Email",
    },
    {
      name: "Contact",
    },
    {
      name: "Store Location Address",
    },
    {
      name: "Actions",
    },
  ];

  const [deleteClicked, setDeleteClicked] = useState(false);
  const [selectedFranchiseId, setSelectedFranchiseId] = useState(null);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [allFranchises, setAllFranchises] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterParams, setFilterParams] = useState({
    duration: null,
  });
  // Debounced search value to avoid rapid API calls
  const [debouncedQuery, setDebouncedQuery] = useState("");

  // Client-side filter to extend search to phone and address too
  const visibleFranchises = useMemo(() => {
    if (!Array.isArray(allFranchises) || (searchQuery || "").trim() === "") {
      return allFranchises;
    }
    const needle = (searchQuery || "").toLowerCase();
    return allFranchises.filter((f) => {
      const business = f?.merchant?.businessName || "";
      const email = f?.email || "";
      const phone = f?.phone || "";
      const address = f?.googlePlaceId?.address || "";
      return (
        business.toLowerCase().includes(needle) ||
        email.toLowerCase().includes(needle) ||
        String(phone).toLowerCase().includes(needle) ||
        address.toLowerCase().includes(needle)
      );
    });
  }, [allFranchises, searchQuery]);

  const getAllFranchises = async (search) => {
    const isClientSearch = Boolean((search || "").trim());
    const params = {
      // When doing client-side search (to include phone/address), keep page 1
      page: isClientSearch ? 1 : currentPage,
      // Service ignores limit unless duration is falsy; leaving as-is
      limit: 10,
      // Avoid passing search to backend so it doesn't narrow by name/email only
      search: isClientSearch ? null : (search || null),
      duration: filterParams.duration?.toLowerCase() || null,
    };

    const franchisePromise = await dispatch(getFranchises(params)).unwrap();
    if (franchisePromise?.success === true) {
      setAllFranchises(franchisePromise?.data);
      setCurrentPage(franchisePromise?.currentPage);
      setTotalPages(franchisePromise?.totalPages);
      // count not used in UI; omit to avoid unused state
    }
  };

  // Debounce searchQuery into debouncedQuery
  useEffect(() => {
    const handle = setTimeout(() => setDebouncedQuery(searchQuery), 400);
    return () => clearTimeout(handle);
  }, [searchQuery]);

  // Single fetch effect: runs when page, merchant, filters, or debouncedQuery change
  useEffect(() => {
    getAllFranchises(debouncedQuery);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusToggled, deleteSuccess, currentPage, selectedMerchant, filterParams, debouncedQuery]);

  const fetchStoreDetails = async (storeId) => {
      try {
        const storeDetailsPromise = await dispatch(
          getLocationById({ id: storeId })
        )?.unwrap();
        if (storeDetailsPromise?.success === true) {
          setStoreDetails(storeDetailsPromise?.data);
          setIsDetailOpen(true);
        }
      } catch (error) {
        console.error("Error fetching offer details:", error);
      }
    };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  const [filterData] = useState([
    {
      id: "duration",
      title: "Duration",
      options: ["Day", "Week", "Month", "Year"],
      defaultValue: "Day",
      multiSelect: false,
    },
  ]);

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        // For multi-select, initialize as array
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        // For single select, initialize as single value
        acc[filter.id] = filter.defaultValue;
      }
      return acc;
    }, {});
  };

  // Initialize selections with the initial state
  const [selections, setSelections] = useState(createInitialState(filterData));

  const handleSelectionChange = (filterId, value) => {
    setSelections((prev) => ({
      ...prev,
      [filterId]: value,
    }));
  };

  // Update the handleReset function
  const handleReset = () => {
    const initialState = createInitialState(filterData);
    setSelections(initialState);

    // Reset filter params to trigger new API call
    setFilterParams({
      duration: null,
    });
  };

  const handleApply = () => {
    console.log("Applying filters:", selections);

    // Update filter params to trigger new API call
    setFilterParams({
      duration: selections.duration,
    });

    setOpen(false);
  };

  // Toggle handler currently unused in this view

  // Hours click handler managed via popup open

  const handleCloseTradeHours = () => {
    setIsTradeOpen(false);
  };

  const handleEditClick = (id) => {
    navigate("/merchant/franchise-form", {
      state: {
        id: id,
      },
    });
  };

  const handleDeleteClick = (id) => {
    setDeleteClicked(true);
    setSelectedFranchiseId(id);
  };

  const handleKeepFranchise = () => {
    setDeleteClicked(false);
  };

  const handleDeleteFranchise = async () => {
    if (selectedFranchiseId !== null) {
      const deletePromise = await dispatch(
        deleteFranchise({ id: selectedFranchiseId })
      )?.unwrap();
      if (deletePromise?.success === true) {
        setDeleteClicked(false);
        setDeleteSuccess(!deleteSuccess);
      }
    }
  };

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    // Reset to first page for a new search term
    setCurrentPage(1);
  };

  const closePopup = () => {
    setIsDetailOpen(false);
  };

  const openPopup = (storeId) => {
    fetchStoreDetails(storeId);
  };
console.log('storeDetails', storeDetails)
  return (
    <>
      {loading === true && <Loader />}
      {isDetailOpen && (
        <DetailsModal
          handleClose={closePopup}
          content={<PopupContent storeDetails={storeDetails} handleDeleteClick={handleDeleteClick} handleEditClick={handleEditClick}/>}
          popupClassName="p-6 w-[335px] sm:w-[600px] md:w-[728px]"
        />
      )}
      {tradeHours !== null && isTradeOpen === true && (
        <TradingHoursPopup
          tradeHours={tradeHours}
          handleCloseTradeHours={handleCloseTradeHours}
        />
      )}
      <div className="flex justify-between col-span-12">
        <BreadCrumsHeader heading="Stores List" items={items} />
        <CreateNewButton
          text={"Create New Store"}
          navigateTo={"/merchant/franchise-form"}
          iconClassName="sm:left-[1%] md:left-[4%] bottom-[30%]"
        />
      </div>
      <div className="w-full flex justify-between items-center mt-4">
        <SearchBar
          parentDivClass="w-[65%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative"
          inputClassName="searchBar w-full p-3 text-[14px] font-poppins font-[400] outline-none"
          iconClassName="absolute sm:right-[5%] sm:bottom-[25%] lg:right-[3%]"
          placeholder="Search"
          value={searchQuery}
          handleChange={(e) => handleSearchChange(e.target.value)}
        />
        <Dropdown
          overlay={
            <FilterPanel
              filterData={filterData}
              selections={selections}
              handleApply={handleApply}
              handleCancel={handleCancel}
              handleReset={handleReset}
              handleSelectionChange={handleSelectionChange}
            />
          }
          trigger={["click"]}
          open={open}
          onOpenChange={handleOpenChange}
          placement="bottomRight"
          overlayStyle={{
            minWidth: "320px",
            maxHeight: "80vh",
            zIndex: 1000,
          }}
          overlayClassName="filter-dropdown-overlay"
        >
          <button className="flex justify-center items-center gap-2 border border-[#00ADEF] rounded-md p-3 text-lg font-medium outline-none h-[40px]">
            <div className="flex items-center gap-2">
              <FiltersIcon className="w-[20px] h-[20px]" />
              <span className="font-[500] text-[14px] font-poppins leading-[22px]">
                Filters
              </span>
            </div>
            <DownArrow />
          </button>
        </Dropdown>
      </div>
      {deleteClicked === true ? (
        <CancelPopup
          handleNo={handleKeepFranchise}
          handleYes={handleDeleteFranchise}
          heading={"Delete Franchise"}
          content={"Are you sure you want to delete this franchise?"}
          image={deleteImg}
        />
      ) : null}
      <div className="col-span-12 mt-8">
        <TableContainer style={{ width: "100%", overflowX: "auto" }}>
          <Table
            sx={{
              minWidth: "800px",
              borderCollapse: "separate",
              borderSpacing: "0px 8px",
            }}
            aria-label="simple table"
          >
            <TableHead className="bg-[#00ADEF]">
              <TableRow
                className="h-[50px]"
                sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                {columns.map((column) => {
                  return <TableCell className="!text-[#FFFFFF]">{column.name}</TableCell>;
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {visibleFranchises && visibleFranchises.length > 0 ? (
                visibleFranchises.map((franchise, index) => {
                  return (
                    <TableRow
                      className="h-[50px]"
                      sx={{
                        boxShadow: "0px 4px 4px 0px #00000040",
                        backgroundColor:
                          (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                      }}
                      key={franchise._id}
                    >
                      <TableCell className="max-w-[50px]">{index + 1}</TableCell>
                      <TableCell
                        title={franchise?.merchant?.businessName}
                        className="max-w-[80px] truncate"
                      >
                        {franchise?.merchant?.businessName}
                      </TableCell>
                      <TableCell
                        title={franchise?.email}
                        className="max-w-[150px] truncate"
                      >
                        {franchise?.email}
                      </TableCell>
                      <TableCell
                        title={franchise?.phone}
                        className="max-w-[100px]"
                      >
                        {franchise?.phone}
                      </TableCell>
                      <TableCell
                        title={franchise?.googlePlaceId?.address}
                        className="max-w-[200px] truncate"
                      >
                        {franchise?.googlePlaceId?.address}
                      </TableCell>
                      <TableCell className="max-w-[120px]">
                        <button
                          className="flex justify-center items-center border border-[#00ADEF] rounded-[6px] p-3 h-[34px]"
                          onClick={() => openPopup(franchise?._id)}
                        >
                          <span className="font-[600] text-[14px] text-[#00ADEF] font-poppins leading-[22px]">
                            View Details
                          </span>
                        </button>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={6} className="text-center py-16">
                    <div className="flex flex-col items-center justify-center">
                      <h3 className="text-xl font-semibold text-gray-800 mb-3">No Stores Found</h3>
                      <p className="text-gray-600 text-center max-w-md leading-relaxed">
                        You haven't created any stores yet.
                      </p>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default FranchiseListTable;
